import { MachinePricingTier, SubscriptionStatus } from "@modules/graphql/types"
import { useOrganizationBaseDetailsQuery } from "@modules/organization/queries.generated"

export function useIsUpgradablePlan(orgId?: string | null) {
  const { data } = useOrganizationBaseDetailsQuery({
    variables: { id: orgId },
    fetchPolicy: "cache-only",
    skip: !orgId,
  })

  const isFreePlan =
    data?.organizationDetails?.billing?.plan?.baseFeatures?.tier ===
    MachinePricingTier.Free

  const isTrialling =
    data?.organizationDetails?.billing?.status === SubscriptionStatus.Trialing

  return isFreePlan || isTrialling
}
